<template>
  <template v-if="image !== null && image !== undefined">
    <source :srcset="image.getTyrionSrc(validSizes[size].type)"
            :media="`(${validSizes[size].media})`" :width="size" v-for="size in Object.keys(validSizes)">
  </template>
  <img v-else src="~/assets/img/blank.jpg"
       class="img-cover"
       loading="lazy">
</template>
<script setup lang="ts">

import {TyrionResourceImageType} from "../../../lib/enums/TyrionResourceImageType";
import Image from "../../../lib/models/Image";
import {computed} from "vue";

const props = defineProps({
  image: Image,
  sizes: String | Array<string>
});

const validSizes = computed(() => {
  const defaultSizes = {
    300: {type: TyrionResourceImageType.w300, media: 'max-width: 350px'},
    500: {type: TyrionResourceImageType.w500, media: 'max-width: 600px'},
    700: {type: TyrionResourceImageType.w700, media: 'max-width: 800px'},
    900: {type: TyrionResourceImageType.w900, media: 'max-width: 1100px'},
    1200: {type: TyrionResourceImageType.w1200, media: 'max-width: 1400px'},
    1400: {type: TyrionResourceImageType.w1400, media: 'max-width: 1600px'},
    1920: {type: TyrionResourceImageType.w1920, media: 'min-width: 1800px'}
  };
  if (props.sizes !== 'all' && Array.isArray(props.sizes)) {
    const filteredSizes = {};
    props.sizes.forEach(size => {
      if (defaultSizes[size]) {
        filteredSizes[size] = defaultSizes[size];
      }
    });
    return filteredSizes;
  } else {
    return defaultSizes;
  }
});

</script>
